module.exports = __webpack_public_path__ + "main-image.7e9f642ab7b3c4d2b4b9d76f447a21ba.png";